export const FETCH_ALLROOM_REQUEST = 'FETCH_ALLROOM_REQUEST'
export const FETCH_ALLROOM_SUCCESS = 'FETCH_ALLROOM_SUCCESS'
export const FETCH_ALLROOM_FALIURE = 'FETCH_ALLROOM_FALIURE'
